import { render, staticRenderFns } from "./ProjDetail.vue?vue&type=template&id=e6046bae&"
import script from "./ProjDetail.vue?vue&type=script&lang=js&"
export * from "./ProjDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports